/**
 * Footer component with information and links
 */

export function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 mt-12 py-8 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-white font-semibold mb-3">About</h3>
            <p className="text-sm">
              HIVE CrossCheck identifies cross-posters across HIVE, Steemit, and Blurt blockchains
              by analyzing author activity and content matching.
            </p>
          </div>
          <div>
            <h3 className="text-white font-semibold mb-3">Resources</h3>
            <ul className="text-sm space-y-2">
              <li>
                <a href="https://hive.blog" target="_blank" rel="noopener noreferrer" className="hover:text-white">
                  🚀 HIVE Blog
                </a>
              </li>
              <li>
                <a href="https://steemit.com" target="_blank" rel="noopener noreferrer" className="hover:text-white">
                  💚 Steemit
                </a>
              </li>
              <li>
                <a href="https://blurt.blog" target="_blank" rel="noopener noreferrer" className="hover:text-white">
                  💙 Blurt
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-white font-semibold mb-3">API Information</h3>
            <ul className="text-sm space-y-1 font-mono text-xs">
              <li>condenser_api.get_discussions_by_created</li>
              <li>condenser_api.get_accounts</li>
              <li>condenser_api.get_content</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-6 text-center text-xs">
          <p>
            Made with ❤️ for the Hive community •{' '}
            <span className="text-slate-500">
              {new Date().getFullYear()} HIVE CrossCheck
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}
